var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApartment = function SvgApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 26.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2390",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4.5 0h17v26h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1h15v24h-15z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2490",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M19.5 6h8v20h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7h6v18h-6z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2491",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M.5 10h6v16h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11h4v14h-4z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 329",
    d: "M1 25.5h27"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 368",
    d: "M9 5.5h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 369",
    d: "M9 9.5h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 372",
    d: "M23 10.5h1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 373",
    d: "M23 13.5h1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 370",
    d: "M9 13.5h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 371",
    d: "M9 17.5h8"
  }))));
};
export default SvgApartment;